import { useState, useRef, useEffect } from "react";
import { Modal } from 'react-bootstrap';
import DeviceService from "../../Services/DeviceService";
import { ReactComponent as Close } from '../../Assets/img/Close.svg';
import { ReactComponent as Save } from '../../Assets/img/Edit-icon.svg';
import { ReactComponent as UploadDeviceIcon } from '../../Assets/img/Upload-icon.svg';
import { ReactComponent as ResetIcon } from '../../Assets/img/Reset-primary-icon.svg';
import { ReactComponent as Error } from '../../Assets/img/Error.svg';

/**
 * Renders edit all pop up to bulk edit devices
 * @component
 * @param {Event} props.onClose() To close pop up
 * @param {Event} props.onSaveClick To Save and Submit the values
 */

function BulkEditDevices(props) {

    //#region States

    const [isActive, setIsActive] = useState(null);
    const [DeviceModels, setDeviceModels] = useState([]);
    const [device, setDevice] = useState({});
    const [error, setError] = useState("");
    const [messagePopup, setMessagePopup] = useState(false);

    //#endregion

    //#region Refs

    const deviceModelIdRef = useRef();

    //#endregion

    //#region useEffect hook

    /**
    * Calls device service to fetch device models
    * runs on every render
    */

    useEffect(() => {
        DeviceService.GetDeviceModels().then((getDeviceModelResponse) => {
            if (getDeviceModelResponse.response == null) {
                setError(getDeviceModelResponse.errors[0].message);
            } else {
                setDeviceModels(getDeviceModelResponse.response);
            }
        }).catch((err) => {
            setError(err.data);
        });
    }, [])

    //#endregion

    return (
        <Modal centered={true} contentClassName="BulkEditDeviceMain" show={true} onHide={props.onClose}>
            <Modal.Header className="AddDeviceHeader" style={{ border: "none" }} closeButton>
                <Modal.Title className="Header"><strong>Bulk Edit Devices</strong></Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding: '0' }}>
                {messagePopup && <div className="alert alert-warning"><Error /><span className="message-popup-title">{error}</span></div>}
                <form onSubmit={(event) => {
                    event.preventDefault();
                    if (isActive == null && deviceModelIdRef.current.value == "") {
                        setError("Select atleast one field");
                        setMessagePopup(true);
                    }
                    else {
                        props.onSaveClick(isActive, deviceModelIdRef.current.value)
                    }

                }} >
                    <div style={{ padding: '3%' }}>
                        <label for="status" className="label">Device status:</label>
                        <br />
                        <select name="status" id="isActive"
                            className="InputField"
                            onChange={(e) => setIsActive(e.target.value)}>
                            <option value={null} selected >-Select-</option>
                            <option value={true} defaultValue>Active</option>
                            <option value={false}>Inactive</option>
                        </select>
                    </div>
                    <div style={{ padding: '3%' }}>
                        <div>
                            <label for="DeviceModel" className="label">Device Model</label>
                            <div>
                                <select className="InputField" ref={deviceModelIdRef}>
                                    <option value="" selected >-Select-</option>
                                    {DeviceModels?.map((DeviceModel) => (
                                        <option value={DeviceModel.Id}>{DeviceModel.Make}-{DeviceModel.Model}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>
                    <Modal.Footer className="AddDeviceFooter" style={{ border: "none" }}>
                        <div>
                            <button type="reset" className="secondary-button" >
                                <span className="secondary-button-icon"><ResetIcon /></span>
                                <span className="secondary-button-text" >Reset</span>
                            </button>
                            &nbsp;
                            <button type="submit" className="primary-button ">
                                <span className="primary-button-icon"><Save /></span>
                                <span className="primary-button-text">Edit</span>
                            </button>

                        </div>
                    </Modal.Footer>

                </form>
            </Modal.Body>

        </Modal>
    );
}

export default BulkEditDevices;